module.exports = __webpack_public_path__ + "static/media/box-important.30090125.png";